exports.components = {
  "component---src-pages-404-index-ts": () => import("./../../../src/pages/404/index.ts" /* webpackChunkName: "component---src-pages-404-index-ts" */),
  "component---src-pages-index-ts": () => import("./../../../src/pages/index.ts" /* webpackChunkName: "component---src-pages-index-ts" */)
}

